import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStorefrontSquare = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31 14.5V9H9V14.5V31H17.25V24.5833H22.75V31H31V14.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 15.4167V16.3334C14.5 17.855 13.2717 19.0834 11.75 19.0834C10.2283 19.0834 9 17.855 9 16.3334V15.4167",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 15.4167V16.3334C20 17.855 18.7717 19.0834 17.25 19.0834C15.7283 19.0834 14.5 17.855 14.5 16.3334V15.4167",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5 15.4167V16.3334C25.5 17.855 24.2717 19.0834 22.75 19.0834C21.2283 19.0834 20 17.855 20 16.3334V15.4167",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 15.4167V16.3334C31 17.855 29.7717 19.0834 28.25 19.0834C26.7283 19.0834 25.5 17.855 25.5 16.3334V15.4167",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgStorefrontSquare);
export default ForwardRef;
